/* eslint max-classes-per-file: 0 */

import { MunMeh as Data, MunMehCollection as Collection } from '@/typings/api/MunMeh'
import { LkRegMehApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class LkRegMehTransformerParams extends TransformerParams {
  // ..
}

export class LkRegMehAdapter extends Adapter<Api> {
    public readonly api = new Api();

    public readonly transformerParams = new LkRegMehTransformerParams();
}
